import styled from "@emotion/styled";
import React from "react";
import { STRINGS } from "../../../strings";
import { translate } from "../../../translate";
import { AppButton } from "../../Generic/AppButton";

type Props = {
  onClickSettings: () => void;
};

export default function VisitsOutsideAvailabilityTitle(props: Props) {
  return (
    <Root>
      <Title>{translate(STRINGS.VISITS_OUTSIDE_YOUR_AVAILABILITY)}</Title>
      <AppButton variant="outline" size="small" onClick={props.onClickSettings}>
        {translate(STRINGS.SETTINGS)}
      </AppButton>
    </Root>
  );
}

const Root = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 16px 0;
`;

const Title = styled.h2`
  font-size: 14px;
  font-weight: 600;
  color: var(--tw-slate-900);
`;
